// extracted by mini-css-extract-plugin
module.exports = {"div":"ReviewModal_div__3UfI7"};